import { useMount } from 'ahooks';
import { TableColumnsType } from 'antd';
import { useAppDispatch } from 'app/hooks';
import logo from 'assets/img/logo.png';
import { JobActivity, JobItem } from 'domains/workspaceDomain';
import NameBadge from 'features/Workspace/components/NameBadge';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import jobService from 'services/jobService';
import { getFullName } from 'utils/misc';
import { RevxTable } from '../../../../../../components/RevxTable/index';
import './Activity.less';

const Activity = (jobData: JobItem) => {
  const { t } = useTranslation();
  const [activities, setActivities] = useState<JobActivity[]>();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  useMount(async () => {
    setLoading(true);
    const res = await jobService.getJobActivities(jobData.id);
    setLoading(false);
    setActivities(res.content);
    dispatch.workspace.getJobItemCount(jobData.id);
  });
  const columns: TableColumnsType<JobActivity> = [
    {
      title: t('workspace.detail.activity.date'),
      dataIndex: 'eventTime',
      key: 'eventTime',
      render(val) {
        return moment(val).format('MM-DD-YYYY');
      },
    },
    {
      title: t('workspace.detail.activity.time'),
      dataIndex: 'time',
      key: 'time',
      render(val, record) {
        return moment(record.eventTime).format('HH:mm A');
      },
    },
    // {
    //   title: t('workspace.detail.activity.status'),
    //   dataIndex: 'status',
    //   key: 'status',
    //   render(status) {
    //     return getFriendlyDisplay(status);
    //   },
    // },
    {
      title: t('workspace.detail.activity.activity'),
      dataIndex: 'content',
      key: 'content',
    },
    {
      title: t('workspace.detail.activity.person'),
      dataIndex: 'person',
      key: 'person',
      render: (text, record) => {
        const name = getFullName({
          firstName: record.creatorFirstName || '',
          lastName: record.creatorLastName || '',
        });

        return (
          <div className="table-tip">
            {!record.creatorFirstName && !record.creatorLastName ? (
              <>
                <img src={logo} alt="" style={{ width: 24, height: 24 }} />
                <span className="table-tip-text">Revshop System</span>
              </>
            ) : (
              <>
                <NameBadge name={name} />
                <span className="table-tip-text">{name}</span>
              </>
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="activity-card">
      <RevxTable<JobActivity>
        loading={loading}
        columns={columns}
        dataSource={activities}
        pagination={false}
        size="small"
      />
    </div>
  );
};

export default Activity;
